/**
 * Created by i.lovenkov on 21.04.17.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _helpers = require('helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    UserInfoRowItem: {
        displayName: 'UserInfoRowItem'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/UserProfile/UserInfoRowItem/UserInfoRowItem.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var UserInfoRowItem = _wrapComponent('UserInfoRowItem')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(UserInfoRowItem, _Component);

    function UserInfoRowItem(props) {
        (0, _classCallCheck3.default)(this, UserInfoRowItem);

        var _this = (0, _possibleConstructorReturn3.default)(this, (UserInfoRowItem.__proto__ || (0, _getPrototypeOf2.default)(UserInfoRowItem)).call(this, props));

        _this.onClickConfirm = function (slug) {
            var funcConfirm = _this.props['onClickConfirm_' + slug];

            if (funcConfirm) {
                // если передан обработчик - вызовем его
                funcConfirm();
            }
        };

        return _this;
    }

    (0, _createClass3.default)(UserInfoRowItem, [{
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForComponent('UserInfoRowItem', null, { folderName: 'UserProfile/UserInfoRowItem' });

            return _react3.default.createElement(View, (0, _extends3.default)({}, this.props, {
                onClickConfirm: this.onClickConfirm
            }));
        }
    }]);
    return UserInfoRowItem;
}(_react2.Component), _class.propTypes = {
    currentValue: _react2.PropTypes.string,
    description: _react2.PropTypes.string,
    disabled: _react2.PropTypes.bool,
    id: _react2.PropTypes.string,
    label: _react2.PropTypes.string,
    lang: _react2.PropTypes.object.isRequired,
    onChange: _react2.PropTypes.func,
    onClickAccept: _react2.PropTypes.func,
    onClickCancel: _react2.PropTypes.func,
    onClickChange: _react2.PropTypes.func,
    onClickConfirm: _react2.PropTypes.func,
    user: _react2.PropTypes.object,
    validate: _react2.PropTypes.object,
    value: _react2.PropTypes.string
}, _temp));

exports.default = UserInfoRowItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UserProfile/UserInfoRowItem/UserInfoRowItem.jsx
// module id = 1779
// module chunks = 0